import {useMemo} from 'react';

import {PartnersResponse} from '~types/Partner';

export default function useFilterPartner(
    partners: PartnersResponse | undefined,
    text: string,
) {
    return useMemo(() => {
        if (!partners || text.length < 1) {
            return [];
        }
        return partners.filter((p) =>
            p?.name?.toLowerCase().includes(text.toLowerCase()),
        );
    }, [partners, text]);
}
